const Checkbox = ({name, checked, label, value, onChange = null, requiredMessage = null }) => (
  <div className="form-check">
    <input 
      className="form-check-input" 
      id={name+label} 
      name={name} 
      type="checkbox" 
      checked={checked} 
      onChange={onChange} 
      value={value}
      required 
      data-val="true" 
      data-val-required={requiredMessage} 
    />
    <label className="form-check-label" htmlFor={name+label}>{label}</label>
    <span className="text-danger field-validation-valid" data-valmsg-for={name} data-valmsg-replace="true"></span>
  </div>
);

export default Checkbox;
